var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, CurrencyInput, Form, Modal, SubmitButton } from "@brushfire/ui";
import { useContext, useEffect, useState } from "react";
import Constants from "../../../data/constants";
import WidgetFieldset from "../../Helpers/WidgetFieldset";
import FormikContextListener from "../../Helpers/FormikContextListener";
import * as Yup from "yup";
import { BulkActionType, isOrderAttendeeOutput } from "./MyDashboard";
import { postAttendeeDonateBulk, postAttendeeShareBulk, putAttendeePaymentBulk } from "../../../data/api";
import { convertCurrencyStrToDecimal, handleErrors, handleSubmittedOrder } from "../../../data/helpers";
import useWidgetHistory from "../../../hooks/useWidgetHistory";
import { useDispatch } from "react-redux";
import { AppFormContext, FooterVisibility } from "../../../App";
import { useIntl } from "react-intl";
import { setPaymentRequiredPayload } from "../../../store/PostAttendeeActions/actions";
import { PaymentPayloadType } from "../../../store/PostAttendeeActions/types";
import useFormatters from "../../../hooks/useFormatters";
import DashboardTotalRow from "./DashboardTotalRow";
var BulkActionForm = function (_a) {
    var eventData = _a.eventData, path = _a.path, kiosk = _a.kiosk, bulkActionStatus = _a.bulkActionStatus, setBulkActionStatus = _a.setBulkActionStatus, children = _a.children, attendeeList = _a.attendeeList, setConfirmationMessage = _a.setConfirmationMessage, showBulkActionSecondStep = _a.showBulkActionSecondStep, setShowBulkActionSecondStep = _a.setShowBulkActionSecondStep;
    var history = useWidgetHistory();
    var dispatch = useDispatch();
    var _b = useContext(AppFormContext), formikContext = _b.formikContext, setFooterVisibility = _b.setFooterVisibility;
    var intl = useIntl();
    var formatCurrency = useFormatters().formatCurrency;
    var _c = __read(useState(null), 2), clearModal = _c[0], setClearModal = _c[1];
    var getInitialValues = function () {
        switch (bulkActionStatus) {
            case BulkActionType.donate:
            case BulkActionType.download:
                return { attendeeIds: [] };
            case BulkActionType.share: {
                var shareValues = {
                    attendeeIds: [],
                    fromName: "",
                    fromEmail: "",
                    recipientEmail: "",
                    message: "",
                };
                return shareValues;
            }
            case BulkActionType.payment: {
                var values_1 = {};
                attendeeList.forEach(function (attendee) {
                    if (attendee.status !== "Cancelled") {
                        var attendeeId = isOrderAttendeeOutput(attendee) ? attendee.attendeeId : attendee.id;
                        if (!Object.prototype.hasOwnProperty.call(values_1, attendeeId) && attendee.hasPaymentsToMake) {
                            values_1[attendeeId] = attendee.displayTotal < 0
                                ? 0
                                : isOrderAttendeeOutput(attendee)
                                    ? attendee.typeAmount - attendee.displayTotal
                                    : attendee.typeAmount - attendee.amount;
                        }
                    }
                });
                var paymentValues = {
                    attendeeInfos: [],
                    attendeeAmounts: values_1,
                    allAmounts: intl.formatNumber(0, {
                        style: "currency",
                        currency: eventData.currency,
                    }),
                };
                return paymentValues;
            }
        }
        return {};
    };
    var getValidationSchema = function () {
        switch (bulkActionStatus) {
            case BulkActionType.donate:
                return Yup.object().shape({
                    attendeeIds: Yup.array().min(1, "Select at least one attendee to donate back"),
                });
            case BulkActionType.share:
                if (showBulkActionSecondStep) {
                    return Yup.object().shape({
                        attendeeIds: Yup.array().min(1, "Select at least one attendee to share"),
                        fromName: Yup.string().required("Your Name is required"),
                        fromEmail: Yup.string()
                            .email("Your Email is required")
                            .required("Your Email is required"),
                        recipientEmail: Yup.string()
                            .email("Gift Recipient's Email is required")
                            .required("Gift Recipient's Email is required"),
                        message: Yup.string().required("Message is required"),
                    });
                }
                else {
                    return undefined;
                }
            case BulkActionType.payment: {
                var amountsSchema_1 = {};
                attendeeList.forEach(function (attendee) {
                    var _a, _b;
                    if (attendee.status !== "Cancelled") {
                        var attendeeId = isOrderAttendeeOutput(attendee) ? attendee.attendeeId : attendee.id;
                        if (!Object.prototype.hasOwnProperty.call(amountsSchema_1, attendeeId) &&
                            attendee.hasPaymentsToMake) {
                            amountsSchema_1[attendeeId] = isOrderAttendeeOutput(attendee)
                                ? Yup.number().max(attendee.remainingBalance, "Payments must be less than remaining balance: ".concat(intl.formatNumber(attendee.remainingBalance, {
                                    style: "currency",
                                    currency: (_a = eventData.currency) !== null && _a !== void 0 ? _a : "USD",
                                })))
                                : Yup.number().max(attendee.typeAmount - attendee.amount, "Payments must be less than remaining balance: ".concat(intl.formatNumber(attendee.typeAmount - attendee.amount, {
                                    style: "currency",
                                    currency: (_b = eventData.currency) !== null && _b !== void 0 ? _b : "USD",
                                })));
                        }
                    }
                });
                return Yup.object().shape({
                    attendeeAmounts: Yup.object().shape(amountsSchema_1),
                });
            }
        }
        return undefined;
    };
    useEffect(function () {
        var _a, _b;
        if (bulkActionStatus !== BulkActionType.none) {
            if ((_b = (_a = formikContext === null || formikContext === void 0 ? void 0 : formikContext.status) === null || _a === void 0 ? void 0 : _a.bag) === null || _b === void 0 ? void 0 : _b.isBulkActionForm) {
                formikContext === null || formikContext === void 0 ? void 0 : formikContext.resetForm({ values: getInitialValues() });
            }
            if (setFooterVisibility) {
                setFooterVisibility(FooterVisibility.show);
            }
        }
        else {
            if (setFooterVisibility) {
                setFooterVisibility(FooterVisibility.default);
            }
        }
    }, [bulkActionStatus]);
    if (bulkActionStatus === BulkActionType.none) {
        return (_jsxs(_Fragment, { children: [children, _jsx(DashboardTotalRow, { attendeeList: attendeeList, bulkActionStatus: bulkActionStatus, path: path })] }));
    }
    var onSubmit = function (values, formikHelpers) {
        var _a;
        if (!showBulkActionSecondStep && [BulkActionType.donate, BulkActionType.share].includes(bulkActionStatus)) {
            setShowBulkActionSecondStep(true);
            formikHelpers.setSubmitting(false);
        }
        else {
            switch (bulkActionStatus) {
                case BulkActionType.donate:
                    postAttendeeDonateBulk(values)
                        .then(function (_a) {
                        var data = _a.data;
                        formikHelpers.setSubmitting(false);
                        handleSubmittedOrder(data.result, eventData, history, true, window.location.pathname);
                    })
                        .catch(function (err) {
                        handleErrors(err, dispatch, formikContext);
                    });
                    break;
                case BulkActionType.share:
                    postAttendeeShareBulk(values)
                        .then(function (_a) {
                        var data = _a.data;
                        if (data) {
                            formikHelpers.setSubmitting(false);
                            setBulkActionStatus(BulkActionType.none);
                            setConfirmationMessage({
                                title: "You're all set!",
                                subtitle: "Your tickets have been shared",
                            });
                        }
                    })
                        .catch(function (err) {
                        handleErrors(err, dispatch, formikContext);
                    })
                        .finally(function () {
                        formikHelpers.setSubmitting(false);
                        setShowBulkActionSecondStep(false);
                    });
                    break;
                case BulkActionType.download:
                    formikHelpers.setSubmitting(false);
                    (_a = window === null || window === void 0 ? void 0 : window.top) === null || _a === void 0 ? void 0 : _a.open("https://".concat(process.env.REACT_APP_DOMAIN, "/").concat(eventData.clientKey, "/").concat(eventData.urlKey, "/").concat(eventData.eventNumber, "/my/attendees/bulk/print/").concat(values.type ? values.type : "", "?data=").concat(values.attendeeIds
                        .join("")
                        .replaceAll("-", "")), "_blank");
                    setShowBulkActionSecondStep(false);
                    break;
                case BulkActionType.payment: {
                    var paymentValues_1 = {
                        attendeeInfos: Object.keys(values.attendeeAmounts).map(function (key) { return ({
                            attendeeId: key,
                            amount: values.attendeeAmounts[key],
                        }); }),
                    };
                    putAttendeePaymentBulk(paymentValues_1)
                        .then(function (res) {
                        if (res.status === 202) {
                            var attendeesWithPayments = Object.keys(values.attendeeAmounts).map(function (key) { return values.attendeeAmounts[key]; });
                            dispatch(setPaymentRequiredPayload({
                                type: PaymentPayloadType.bulkAttendeePaymentUpdate,
                                payload: res.data,
                                originalFields: paymentValues_1,
                                summaryText: "You're about to apply a payment toward ".concat(attendeesWithPayments.length, " attendee").concat(attendeesWithPayments.length === 1 ? "" : "s", " in the total amount of ").concat(formatCurrency(res.data.total), "."),
                            }));
                        }
                        else {
                            setConfirmationMessage({
                                title: "You're all set!",
                                subtitle: "Your process was completed",
                            });
                            setBulkActionStatus(BulkActionType.none);
                            setShowBulkActionSecondStep(false);
                        }
                    })
                        .catch(function (err) {
                        handleErrors(err, dispatch, formikContext);
                        setShowBulkActionSecondStep(false);
                    })
                        .finally(function () {
                        formikHelpers.setSubmitting(false);
                    });
                    break;
                }
            }
        }
    };
    var initialValues = getInitialValues();
    return (_jsx(Form, __assign({ initialValues: initialValues, validationSchema: getValidationSchema(), onSubmit: onSubmit, formikBagProps: {
            submitButtonLabel: bulkActionStatus === BulkActionType.share
                ? "Share"
                : bulkActionStatus === BulkActionType.download
                    ? "Download"
                    : bulkActionStatus === BulkActionType.donate
                        ? "Donate"
                        : "Continue",
            bulkActionStatus: bulkActionStatus,
            showRegisterFooter: true,
            isBulkActionForm: true,
        }, autoComplete: kiosk ? "new-off" : "on", useUnsavedPrompt: false }, { children: function (_a) {
            var _b, _c, _d, _e, _f, _g, _h, _j, _k;
            var formikContext = _a.formikContext;
            var setPaymentFields = function (amount) {
                var num = convertCurrencyStrToDecimal(amount, intl, eventData.currency);
                var values = {};
                attendeeList.forEach(function (attendee) {
                    if (attendee.status !== "Cancelled") {
                        var attendeeId = isOrderAttendeeOutput(attendee) ? attendee.attendeeId : attendee.id;
                        if (!Object.prototype.hasOwnProperty.call(values, attendeeId) &&
                            attendee.hasPaymentsToMake) {
                            values[attendeeId] = num;
                        }
                    }
                });
                formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue("attendeeAmounts", values);
                formikContext === null || formikContext === void 0 ? void 0 : formikContext.setFieldValue("allAmounts", intl.formatNumber(num, {
                    style: "currency",
                    currency: eventData.currency,
                }));
            };
            var allSelected = true;
            attendeeList.forEach(function (attendee) {
                var _a;
                var attendeeId = isOrderAttendeeOutput(attendee) ? attendee.attendeeId : attendee.id;
                if (attendee.status !== "Cancelled" &&
                    (bulkActionStatus !== BulkActionType.share || attendee.shareEnabled) &&
                    (bulkActionStatus !== BulkActionType.download || attendee.generatesTicket) &&
                    !((_a = formikContext.values.attendeeIds) === null || _a === void 0 ? void 0 : _a.includes(attendeeId))) {
                    allSelected = false;
                }
            });
            if (!formikContext.status.bag) {
                formikContext.status.bag = {};
            }
            // console.log("formikContext.values?.attendeeAmounts", formikContext.values?.attendeeAmounts);
            formikContext.status.bag.disableCartButton =
                ((_d = (_c = (_b = formikContext.values) === null || _b === void 0 ? void 0 : _b.attendeeIds) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) === 0 &&
                    !Object.values(((_f = (_e = formikContext.values) === null || _e === void 0 ? void 0 : _e.attendeeAmounts) !== null && _f !== void 0 ? _f : {})).some(function (a) { return a > 0; });
            formikContext.status.bag.isBulkActionForm = true;
            return (_jsxs(_Fragment, { children: [_jsxs(WidgetFieldset, { children: [_jsx(FormikContextListener, { currentPath: path, path: [
                                    Constants.Routes.myDashboard,
                                    Constants.Routes.myAttendeesShare,
                                    Constants.Routes.myOrderAttendeesShare,
                                    Constants.Routes.myGroupAttendeesShare,
                                    Constants.Routes.myAttendeesDonate,
                                    Constants.Routes.myOrderAttendeesDonate,
                                    Constants.Routes.myGroupAttendeesDonate,
                                    Constants.Routes.myAttendeesDownload,
                                    Constants.Routes.myOrderAttendeesDownload,
                                    Constants.Routes.myGroupAttendeesDownload,
                                    Constants.Routes.myAttendeesPayment,
                                    Constants.Routes.myOrderAttendeesPayment,
                                    Constants.Routes.myGroupAttendeesPayment,
                                ], formikContext: formikContext, active: true, initialValues: initialValues, focusDelay: 500 }), bulkActionStatus === BulkActionType.donate && (_jsxs("div", __assign({ className: "d-flex" }, { children: [_jsx("div", __assign({ className: "flex-1" }, { children: !showBulkActionSecondStep && (_jsxs("h5", { children: ["Select which", " ", eventData.verbiage === "Tickets" ? "ticket" : "registration", "(s) you would like to donate."] })) })), _jsx("div", __assign({ style: { marginRight: "8px" } }, { children: _jsx("div", __assign({ className: "ta-right p-left donate-back-button" }, { children: !showBulkActionSecondStep && (_jsxs(_Fragment, { children: [_jsxs(Button, __assign({ purpose: "plain", classes: "btn-sm btn-outline btn-block", onClick: function (evt) {
                                                            evt.preventDefault();
                                                            evt.stopPropagation();
                                                            formikContext.setValues({
                                                                attendeeIds: allSelected
                                                                    ? []
                                                                    : attendeeList.map(function (a) {
                                                                        return a.status !== "Cancelled"
                                                                            ? isOrderAttendeeOutput(a)
                                                                                ? a.attendeeId
                                                                                : a.id
                                                                            : null;
                                                                    }),
                                                            });
                                                        } }, { children: [allSelected ? "Deselect" : "Select", " All"] })), _jsx("div", __assign({ className: "ta-center m-top-sm" }, { children: _jsx("a", __assign({ href: "#", onClick: function (evt) {
                                                                evt.preventDefault();
                                                                evt.stopPropagation();
                                                                setBulkActionStatus(BulkActionType.none);
                                                                setShowBulkActionSecondStep(false);
                                                            } }, { children: "Cancel" })) }))] })) })) }))] }))), bulkActionStatus === BulkActionType.share && (_jsxs("div", __assign({ className: "d-flex" }, { children: [_jsx("div", __assign({ className: "flex-1" }, { children: !showBulkActionSecondStep && (_jsxs("h5", { children: ["Select which", " ", eventData.verbiage === "Tickets" ? "ticket" : "registration", "(s) you would like to share."] })) })), _jsx("div", __assign({ style: { marginRight: "8px" } }, { children: _jsx("div", __assign({ className: "ta-right p-left donate-back-button" }, { children: !showBulkActionSecondStep && (_jsxs(_Fragment, { children: [_jsxs(Button, __assign({ purpose: "plain", classes: "btn-sm btn-outline btn-block", onClick: function (evt) {
                                                            evt.preventDefault();
                                                            evt.stopPropagation();
                                                            formikContext.setFieldValue("attendeeIds", allSelected
                                                                ? []
                                                                : attendeeList.map(function (a) {
                                                                    return a.status !== "Cancelled" &&
                                                                        a.shareEnabled &&
                                                                        a.generatesTicket
                                                                        ? isOrderAttendeeOutput(a)
                                                                            ? a.attendeeId
                                                                            : a.id
                                                                        : null;
                                                                }));
                                                        } }, { children: [allSelected ? "Deselect" : "Select", " All"] })), _jsx("div", __assign({ className: "ta-center m-top-sm" }, { children: _jsx("a", __assign({ href: "#", onClick: function (evt) {
                                                                evt.preventDefault();
                                                                evt.stopPropagation();
                                                                setBulkActionStatus(BulkActionType.none);
                                                                setShowBulkActionSecondStep(false);
                                                            } }, { children: "Cancel" })) }))] })) })) }))] }))), bulkActionStatus === BulkActionType.download && (_jsxs("div", __assign({ className: "d-flex" }, { children: [_jsx("div", __assign({ className: "flex-1" }, { children: _jsxs("h5", { children: ["Select which ", eventData.verbiage === "Tickets" ? "ticket" : "registration", "(s) you would like to download."] }) })), _jsx("div", __assign({ style: { marginRight: "8px" } }, { children: _jsxs("div", __assign({ className: "ta-right p-left donate-back-button" }, { children: [_jsxs(Button, __assign({ purpose: "plain", classes: "btn-sm btn-outline btn-block", onClick: function (evt) {
                                                        evt.preventDefault();
                                                        evt.stopPropagation();
                                                        formikContext.setFieldValue("attendeeIds", allSelected
                                                            ? []
                                                            : attendeeList.map(function (a) {
                                                                return a.status !== "Cancelled" && a.generatesTicket
                                                                    ? isOrderAttendeeOutput(a)
                                                                        ? a.attendeeId
                                                                        : a.id
                                                                    : null;
                                                            }));
                                                    } }, { children: [allSelected ? "Deselect" : "Select", " All"] })), _jsx("div", __assign({ className: "ta-center m-top-sm" }, { children: _jsx("a", __assign({ href: "#", onClick: function (evt) {
                                                            evt.preventDefault();
                                                            evt.stopPropagation();
                                                            setBulkActionStatus(BulkActionType.none);
                                                            setShowBulkActionSecondStep(false);
                                                        } }, { children: "Cancel" })) }))] })) }))] }))), bulkActionStatus === BulkActionType.payment && (_jsxs("div", __assign({ className: "d-flex" }, { children: [_jsxs("div", __assign({ className: "flex-1" }, { children: [_jsx("h5", { children: "Want to make payments for all attendees at once?" }), _jsx("p", { children: "Enter the amount here or enter custom amounts per attendee below" })] })), _jsx("div", __assign({ style: { marginRight: "8px" } }, { children: _jsxs("div", __assign({ className: "ta-right p-left payment-input-container" }, { children: [_jsx("div", __assign({ className: "ta-center m-bottom-sm" }, { children: "Set all amounts to:" })), _jsx(CurrencyInput, { label: "Custom Price", id: "allAmounts", name: "allAmounts", isFieldRequired: true, currency: eventData.currency, onChange: function (e) {
                                                        setPaymentFields(e.target.value);
                                                    }, onBlur: function (e) {
                                                        setPaymentFields(e.target.value);
                                                    }, onKeyDown: function (e) {
                                                        if (e.key === "Enter") {
                                                            setPaymentFields(e.target.value);
                                                        }
                                                    }, defaultValue: intl.formatNumber(0, {
                                                        style: "currency",
                                                        currency: eventData.currency,
                                                    }), hiddenLabel: true, className: "field w-100", fieldClassName: "ta-right" }), _jsxs("div", __assign({ className: "ta-center m-top-sm" }, { children: [_jsx("a", __assign({ href: "#", onClick: function (evt) {
                                                                evt.preventDefault();
                                                                evt.stopPropagation();
                                                                setClearModal("Reset");
                                                            } }, { children: "Reset" })), " or ", _jsx("a", __assign({ href: "#", onClick: function (evt) {
                                                                evt.preventDefault();
                                                                evt.stopPropagation();
                                                                setClearModal("Cancel");
                                                            } }, { children: "Cancel" }))] })), _jsx(Modal, __assign({ closeButton: false, size: "sm", show: !!clearModal, setShow: setClearModal }, { children: _jsxs("div", { children: [_jsx("h6", __assign({ className: "ta-center" }, { children: clearModal === "Reset"
                                                                    ? "You are about to lose all current changes. Do you want to reset all values back to their original default values?"
                                                                    : "Do you want to cancel all unsaved payments?" })), _jsxs("div", __assign({ className: "modal-footer border-0 p-0 p-top" }, { children: [_jsx(SubmitButton, __assign({ component: Button, onClick: function () {
                                                                            if (clearModal === "Reset") {
                                                                                formikContext === null || formikContext === void 0 ? void 0 : formikContext.resetForm();
                                                                            }
                                                                            else {
                                                                                setBulkActionStatus(BulkActionType.none);
                                                                                setShowBulkActionSecondStep(false);
                                                                            }
                                                                            setClearModal(null);
                                                                        }, purpose: "danger", classes: "btn-sm btn-block p-0 m-0" }, { children: _jsx(_Fragment, { children: "Yes" }) })), _jsx(Button, __assign({ busy: false, type: "button", purpose: "plain", onClick: function () { return setClearModal(null); }, classes: "btn-block clear-cart-cancel" }, { children: _jsx("small", { children: "No" }) }))] }))] }) }))] })) }))] }))), children, bulkActionStatus === BulkActionType.share && showBulkActionSecondStep && (_jsxs(_Fragment, { children: [_jsx(Form.Field, { name: "fromName", id: "fromName", label: "Your Name", autoComplete: !kiosk }), _jsx(Form.Field, { name: "fromEmail", id: "fromEmail", label: "Your Email", type: "email", autoComplete: !kiosk }), _jsx(Form.Field, { name: "recipientEmail", id: "recipientEmail", label: "Recipient's Email", type: "email", autoComplete: !kiosk }), _jsx(Form.Field, { component: Form.Input.TextArea, name: "message", id: "message", label: "Message", autoComplete: !kiosk })] })), bulkActionStatus === BulkActionType.donate && showBulkActionSecondStep && (_jsxs(_Fragment, { children: [_jsxs("h4", __assign({ className: "semi-bold", style: { marginTop: "-25px", marginBottom: "20px" } }, { children: ["Are you sure you want to donate ", (_h = (_g = formikContext.values) === null || _g === void 0 ? void 0 : _g.attendeeIds) === null || _h === void 0 ? void 0 : _h.length, " ", "ticket", ((_k = (_j = formikContext.values) === null || _j === void 0 ? void 0 : _j.attendeeIds) === null || _k === void 0 ? void 0 : _k.length) === 1 ? "" : "s", " back?"] })), _jsx("p", { children: "Cancellation is not available online for this event, but you can donate them back. These tickets will immediately be returned and the ticketholders will not be able to attend this event." }), _jsx("p", { children: "You'll receive a confirmation receipt via email." }), _jsx("p", __assign({ className: "bold" }, { children: _jsx("i", { children: "This action cannot be undone." }) }))] }))] }), _jsx(DashboardTotalRow, { attendeeList: attendeeList, bulkActionStatus: bulkActionStatus, path: path, formikContext: formikContext })] }));
        } })));
};
export default BulkActionForm;
